import request from '@/utils/request'

const api = {
  page: '/biz/chat-report-admin/page',
  detail: '/biz/chat-report-admin/detail',
  process: '/biz/chat-report-admin/process',
  contextMessages: '/biz/chat-report-admin/context-messages',
  delete: '/biz/chat-report-admin/delete',
}

/**
 * 分页查询
 */
export function page(param) {
  return request({
    url: api.page,
    method: 'post',
    data: param,
  })
}

/**
 * 查询详情
 */
export function detail(id) {
  return request({
    url: api.detail,
    method: 'get',
    params: { id },
  })
}

/**
 * 处理举报
 */
export function process(data) {
  return request({
    url: api.process,
    method: 'post',
    data,
  })
}

/**
 * 拉取上下文消息
 */
export function contextMessages(reportId) {
  return request({
    url: api.contextMessages,
    method: 'get',
    params: { reportId },
  })
}

/**
 * 删除举报
 */
export function del(id) {
  return request({
    url: api.delete,
    method: 'delete',
    params: { id },
  })
}
